/**
 * DTO for Pet response from backend.
 */
export class PetResponse {
  constructor(
    id,
    name,
    race,
    imageThumbUrl,
    imageCardUrl,
    imageDetailUrl,
    ownerId,
    ownerName,
    ownerEmail,
    ownerPhone,
    vaccinations,
    createdAt,
    updatedAt
  ) {
    this.id = id;
    this.name = name;
    this.race = race;
    this.imageThumbUrl = imageThumbUrl;
    this.imageCardUrl = imageCardUrl;
    this.imageDetailUrl = imageDetailUrl;
    this.ownerId = ownerId;
    this.ownerName = ownerName;
    this.ownerEmail = ownerEmail;
    this.ownerPhone = ownerPhone;
    this.vaccinations = Array.isArray(vaccinations) ? vaccinations : [];
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  /**
   * Create PetResponse from JSON object.
   */
  static fromJSON(json) {
    return new PetResponse(
      json.id,
      json.name,
      json.race,
      json.imageThumbUrl,
      json.imageCardUrl,
      json.imageDetailUrl,
      json.ownerId,
      json.ownerName,
      json.ownerEmail,
      json.ownerPhone,
      json.vaccinations,
      json.createdAt,
      json.updatedAt
    );
  }
}
